<template>
    <div id="GeoRefs" class="starter-template" :key="key">
        <b-container fluid>
            <b-row class="text-center" style="padding-top: 6px">
                <b-col>
                    <div class="text-center shad">
                        <h4  v-if="selected == 'travels'" class="txtShad">{{ $t('DEF_AREA') }}</h4>
                        <h4 v-else class="txtShad">{{ $t('WHERE_TO') }}</h4>
                    </div>
                </b-col>


            </b-row>
            <b-row align-h="center" style="padding-top: 6px">
                <b-col cols="1"></b-col>
                <b-col>
                    <div class="tbl1Name text-center">
                        <h5 class="txtShad">{{ $t('COUNTRY') }}</h5>
                    </div>
                    <b-form-select
                        v-if="intLoc=='ru'"
                        v-model="selCountryRu"
                        :options="optCountryRu"
                        @change="chCountry('ru')"
                    >
                    </b-form-select>
                    <b-form-select
                        v-else
                        v-model="selCountryEn"
                        :options="optCountryEn"
                        @change="chCountry('en')"
                    >
                    </b-form-select>
                </b-col>
                <b-col>
                    <div v-if="optDistrictRu[0].text">
                        <div class="tbl1Name text-center">
                            <h5 class="txtShad">{{ $t('DISTRICT') }}</h5>
                        </div>
                        <b-form-select
                            v-if="intLoc=='ru'"
                            v-model="selDistrictRu"
                            :options="optDistrictRu"
                            @change="chDistrict('ru')"
                        >
                        </b-form-select>
                        <b-form-select
                            v-else
                            v-model="selDistrictEn"
                            :options="optDistrictEn"
                            @change="chDistrict('en')"
                        >
                        </b-form-select>
                    </div>
                </b-col>
                <b-col>
                    <div v-if="optCityRu[0].text">
                        <div class="tbl1Name text-center">
                            <h5 class="txtShad">{{ $t('CITY') }}</h5>
                        </div>
                        <b-form-select
                            v-if="intLoc=='ru'"
                            v-model="selCityRu"
                            :options="optCityRu"
                            @change="chCity('ru')"
                        >
                        </b-form-select>
                        <b-form-select
                            v-else
                            v-model="selCityEn"
                            :options="optCityEn"
                            @change="chCity('en')"
                        >
                        </b-form-select>
                    </div>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
        </b-container>
        <br>
        <b-container fluid v-if="selected === 'travels'">
            <b-row >
                <b-col>
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('TRIPS') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                        id="listTableT"
                        selectable
                        :items="itemsT"
                        :fields="fields"
                        :per-page=0
                        :current-page="curPageT"
                        striped
                        head-row-variant="info"
                        @row-selected="onRowSelectedT"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthT>10"
                        v-model="curPageT"
                        :total-rows="rowsT"
                        :per-page="perPage"
                        aria-controls="listTableT"
                        pills
                    ></b-pagination>
                </b-col>
                <b-col>
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('PLACES') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                            id="listTableP"
                            selectable
                            :items="itemsP"
                            :fields="fields"
                            :per-page=0
                            :current-page="curPageP"
                            striped
                            head-row-variant="info"
                            @row-selected="onRowSelectedP"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthP>10"
                                  v-model="curPageP"
                                  :total-rows="rowsP"
                                  :per-page="perPage"
                                  aria-controls="listTableP"
                                  pills
                    ></b-pagination>
                </b-col>
            </b-row>
            <br><br><br>
        </b-container>

        <b-container  v-if="selected === 'offers'">
            <b-row >
                <b-col>
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('OUTINGS') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                            id="listTableO"
                            selectable
                            :items="itemsO"
                            :fields="fieldsO"
                            :per-page=0
                            :current-page="curPageO"
                            striped
                            head-row-variant="info"
                            @row-selected="onRowSelectedO"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthO>10"
                                  v-model="curPageO"
                                  :total-rows="rowsO"
                                  :per-page="perPage"
                                  aria-controls="listTableO"
                                  pills
                    ></b-pagination>
                </b-col>
            </b-row>
            <b-row v-if="selected === 'offers' && geoType">
                <b-col>
                    <b-button :pressed.sync="filterToggle">{{$t('FILTER')}}</b-button>
                    <b-button variant="success" class="m-2" v-if="filterToggle" @click="getGeoOutings()">
                        {{ $t("SHOW")}}
                    </b-button>
                </b-col>
            </b-row>

            <b-row v-show="filterToggle">
                <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-row>
                            <b-col>
                                {{$t('OUTING_TYPE')}}
                            </b-col>
                            <b-col cols="2">
                                <b-button>
                            <span  v-b-popover.hover.top="$t('CLEAR')" @click="selWayType=[]; selSubjType=[]; individ='false'">
                                <font-awesome-icon icon="broom" size="lg"/>
                            </span>
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-form-checkbox
                                id="checkbox-1"
                                v-model="individ"
                                name="checkbox-1"
                                value="true"
                                unchecked-value="false"
                        >
                            {{$t('C_INDIVID')}}
                        </b-form-checkbox>
                        <br>
                        <b-form-checkbox-group
                                id="checkbox-group-1"
                                v-model="selWayType"
                                :options="optWayType"
                                :aria-describedby="ariaDescribedby"
                                name="flavour-1"
                        ></b-form-checkbox-group>
                    </b-form-group>
                    <b-form-group v-slot="{ ariaDescribedby2 }">
                        <b-form-checkbox-group
                                id="checkbox-group-2"
                                v-model="selSubjType"
                                :options="optSubjType"
                                :aria-describedby="ariaDescribedby2"
                                name="flavour-2"
                        ></b-form-checkbox-group>
                    </b-form-group>
                    <b-col>
                        <b-button @click="geoChooser=true">{{$t('WHERE_FROM')}}</b-button>
                        <span class="m-1" v-if="startCountry">
                            {{ startCountry }} - {{ startDistrict}} - {{ startCity }}
                        </span>
                    </b-col>

<!--
                        <b-button @click="$bvModal.hide('modal-filter')">
                            {{ $t("CANCEL")}}
                        </b-button>
-->
                </b-col>
            </b-row>

        </b-container>

        <b-container fluid class="footer text-center">
            <b-row>
                <b-col>
                    <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                        <b-form-radio value="travels">{{ $t('TRAVELS') }}</b-form-radio>
                        <b-form-radio value="offers">{{ $t('OFFERS') }}</b-form-radio>
                        <b-button class="m-1" v-if="showMapBtn && selected === 'travels'">
                            <span  v-b-popover.hover.top="this.$t('MAP')" @click="areaMap()">
                                <font-awesome-icon icon="globe" size="lg"/>
                            </span>
                        </b-button>

                        <b-button class="m-1">
                            <span  v-b-popover.hover.top="this.$t('CLEAR')" @click="clear()">
                                <font-awesome-icon icon="broom" size="lg"/>
                            </span>
                        </b-button>
                    </b-form-radio-group>
                </b-col>
                <b-col v-if="curUserName=='admin'">
                    <b-form-checkbox-group>
                        <b-form-checkbox class="m-1" v-model="untieGeo" value="true">
                            <span  v-b-popover.hover.top="this.$t('UNTIE')">
                                <font-awesome-icon icon="unlink" size="lg"/>
                            </span>
                        </b-form-checkbox>
                        <b-button class="m-1">
                            <span  v-b-popover.hover.top="this.$t('DEL_GEO')" @click="$bvModal.show('modal-del')">
                                <font-awesome-icon icon="trash-alt" size="lg"/>
                            </span>
                        </b-button>
                    </b-form-checkbox-group>
            </b-col>
        </b-row>

        </b-container>

        <b-modal id="modal-del" ref="modal-del" no-close-on-backdrop>
            <template v-slot:modal-header>
                {{ $t("SURE")}}
                <b-button size="sm" @click="$bvModal.hide('modal-del')">
                    x
                </b-button>
            </template>

            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('modal-del')">
                    {{ $t("CANCEL")}}
                </b-button>
                <b-button variant="danger" @click="del()">
                    {{ $t("DELETE")}}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-untie" ref="modal-untie" no-close-on-backdrop>
            <template v-slot:modal-header>
                {{ $t("SURE")}}
                <b-button size="sm" @click="$bvModal.hide('modal-untie')">
                    x
                </b-button>
            </template>

            <template v-slot:modal-footer>
                <b-button @click="$bvModal.hide('modal-untie')">
                    {{ $t("CANCEL")}}
                </b-button>
                <b-button variant="danger" @click="untie()">
                    {{ $t("UNTIE")}}
                </b-button>
            </template>
        </b-modal>

        <GeoChooser
                v-on:retFromGeoChooser="retFromGeoChooser"
                :key="myKey"
                v-if="geoChooser"
                ref="GeoChooser"
                v-bind:title="title"
                v-bind:retOnce=false
        />


    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BFormSelect, BTable, BPagination, BModal, BFormGroup, BFormRadioGroup,
    BFormRadio, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';
import GeoChooser from "./GeoChooser.vue";

export default {
  name: 'GeoRefs',
  components: {
    GeoChooser,
    BContainer, BRow, BCol, BButton, BFormSelect, BTable, BPagination, BModal, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckbox, BFormCheckboxGroup
  },
  data: function() {
    return {
        key: 0,
        userName: '',
        curUserName: '',
        itemName: '',
        itemType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        city: '',
        river: '',
        lake: '',
        mountain: '',
        selCountryRu: '',
        selCountryEn: '',
        optCountryRu: [{}],
        optCountryEn: [{}],
        selDistrictRu: '',
        selDistrictEn: '',
        optDistrictRu: [{}],
        optDistrictEn: [{}],
        selCityRu: '',
        selCityEn: '',
        optCityRu: [{}],
        optCityEn: [{}],
        sure: null,
        refType: null,
        intLoc: this.$i18n.locale,
        item: '',
        itemsT: [{}],
        selectedT: null,
        listLengthT: 1,
        perPage: 10,
        curPageT: 1,
        itemsP: [{}],
        selectedP: null,
        listLengthP: 1,
        curPageP: 1,
        itemsO: [{}],
        selectedO: null,
        listLengthO: 1,
        curPageO: 1,
        geoType: '',
        selected: 'travels',
        chsnGeo: '',
        untieGeo: false,
        showMapBtn: false,
        individ: 'false',
        fixOld: false,
        selWayType: [],
        optWayType: [
            { text: this.$t('OU_FOOT'), value: 'foot' },
            { text: this.$t('OU_CAR'), value: 'car' },
            { text: this.$t('OU_BUS'), value: 'bus' },
            { text: this.$t('OU_TRAM'), value: 'tram' },
            { text: this.$t('OU_TRAIN'), value: 'train' },
            { text: this.$t('OU_SHIP'), value: 'ship' },
            { text: this.$t('OU_PLANE'), value: 'plane' },
            { text: this.$t('OU_VELO'), value: 'velo' },
            { text: this.$t('OU_SKI'), value: 'ski' },
            { text: this.$t('OU_VRT'), value: 'virtual' }
        ],
        selSubjType: [],
        optSubjType: [
            { text: this.$t('C_INTRO'), value: 'intro' },
            { text: this.$t('C_CULTURE'), value: 'culture' },
            { text: this.$t('History'), value: 'history' },
            { text: this.$t('Architecture'), value: 'architect' },
            { text: this.$t('Religion'), value: 'religion' },
            { text: this.$t('C_WARFARE'), value: 'warfare' },
            { text: this.$t('C_INDUSTRY'), value: 'industry' },
            { text: this.$t('Science'), value: 'science' },
            { text: this.$t('C_SPORT'), value: 'sport' },
            { text: this.$t('C_HEALTH'), value: 'health' },
            { text: this.$t('C_NATURE'), value: 'nature' },
            { text: this.$t('Landfill'), value: 'rural' },
            { text: this.$t('C_TRANSPORT'), value: 'transport' },
            { text: this.$t('C_CHILDREN'), value: 'children' },
            { text: this.$t('C_PERSON'), value: 'person' },
            { text: this.$t('C_TASTING'), value: 'tasting' },
            { text: this.$t('C_QUEST'), value: 'quest' }
        ],
        geoChooser: false,
        filterToggle: false,
        myKey: 0,
        startCountry: '',
        startDistrict: '',
        startCity: '',
        title: ''
    }
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    this.getCountries();
  },
  methods: {
    async getCountries() {
        this.chsnGeo = 'country';
        try {
            const response = await this.$http.get('/getCountries', {
                params: {
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            this.optCountryRu = response.data.optRefsRu;
            this.optCountryEn = response.data.optRefsEn;
            this.selCityRu=''; this.selCityEn='';
            this.districtRu = ''; this.districtEn = '';
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getDistricts() {
        this.chsnGeo = 'district';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.cityRu = '';
        this.cityEn = '';
        this.itemsT = [{}];
        this.itemsP = [{}];
        this.itemsO = [{}];
        try {
            const response = await this.$http.get('/getDistricts', {

                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            if(
                typeof response.data == 'undefined' ||
                response.data === '' ||
                response.data.optRefsRu.length === 0 ||
                response.data.optRefsEn.length === 0
              ) {
                //this.clear();
                return;
            }
            this.optDistrictRu = response.data.optRefsRu;
            this.optDistrictEn = response.data.optRefsEn;

        }
        catch(error) {
            // return;
            if(typeof error.response === 'undefined') this.$serveErr('GeoRefs: getDistricts() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    async getCities() {
        this.chsnGeo = 'city';
        try {
            const response = await this.$http.get('/getCities', {
                params: {
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    resType: this.selected,
                    intLoc: this.intLoc
                }
            });
            if(typeof response.data == 'undefined' ||
                response.data === '' ||
                typeof response.data.optRefsRu == 'undefined' ||
                response.data.optRefsRu.length === 0 ||
                response.data.optRefsEn.length === 0)
                    //this.clear();
                    return;
            this.optCityRu = response.data.optRefsRu;
            this.optCityEn = response.data.optRefsEn;
        }
        catch(error) {
            //return;
            if(typeof error.response === 'undefined') this.$serveErr('GeoRefs: getCities() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    chCountry(code) {
        this.showMapBtn = true;
        if(code==='ru') {
            this.countryRu = this.optCountryRu[this.selCountryRu].text;
            this.countryEn = this.optCountryEn[this.selCountryRu].text;
            this.selCountryEn = this.optCountryEn[this.selCountryRu].value;
        } else {
            this.countryEn = this.optCountryEn[this.selCountryEn].text;
            this.countryRu = this.optCountryRu[this.selCountryEn].text;
            this.selCountryRu = this.optCountryRu[this.selCountryEn].value;
        }
        this.selDistrictRu=''; this.selDistrictEn='';
        this.selCityRu=''; this.selCityEn='';
        this.districtRu = ''; this.districtEn = '';
        this.cityRu = ''; this.cityEn = '';
        this.geoType = 'country';
        if(this.selected === 'travels') {
            this.getGeoTrips();
            this.getGeoPlaces();
        }
        else this.getGeoOutings();
        this.getDistricts();
    },
    chDistrict(code) {
        if(code==='ru') {
            this.districtRu = this.optDistrictRu[this.selDistrictRu].text;
            this.districtEn = this.optDistrictEn[this.selDistrictRu].text;
            this.selDistrictEn = this.optDistrictEn[this.selDistrictRu].value;
        } else {
            this.districtEn = this.optDistrictEn[this.selDistrictEn].text;
            this.districtRu = this.optDistrictRu[this.selDistrictEn].text;
            this.selCountryRu = this.optDistrictRu[this.selDistrictEn].value;
        }
        this.geoType = 'district';
        this.selCityRu=''; this.selCityEn='';
        this.cityRu = ''; this.cityEn = '';
        if(this.selected === 'travels') {
            this.getGeoTrips();
            this.getGeoPlaces();
        }
        else this.getGeoOutings();
        this.getCities();
    },
    chCity(code) {
        if(code==='ru') {
            this.cityRu = this.optCityRu[this.selCityRu].text;
            this.cityEn = this.optCityEn[this.selCityRu].text;
            this.selCityEn = this.optCityEn[this.selCityRu].value;
        } else {
            this.cityEn = this.optCityEn[this.selCityEn].text;
            this.cityRu = this.optCityRu[this.selCityEn].text;
            this.selCityRu = this.optCityRu[this.selCityEn].value;
        }
        this.geoType = 'city';
        if(this.selected === 'travels') {
            this.getGeoTrips();
            this.getGeoPlaces();
        }
        else this.getGeoOutings();
    },
    async getGeoTrips() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoTrips', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageT
                }
            });
            this.itemsT = response.data.itemList;
            this.listLengthT = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getGeoPlaces() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoPlaces', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageP
                }
            });
            this.itemsP = response.data.itemList;
            this.listLengthP = response.data.listLen;
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getGeoOutings() {
        if(!this.geoType) return;
        this.$bvModal.hide("modal-filter");
        let json = [];
        let j=0;
        for(let i=0; i<this.selWayType.length; i++) {
            if(this.selWayType[i]) {
                json[j] = this.selWayType[i];
                j++;
            }
        }
        for(let i=0; i<this.selSubjType.length; i++) {
            if(this.selSubjType[i]) {
                json[j] = this.selSubjType[i];
                j++;
            }
        }
        if(this.individ === 'true') json[j] = 'individ';
        try {
            const response = await this.$http.get('/getGeoOutings', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageO,
                    featuresJSON: JSON.stringify(json)
                }
            });
            this.itemsO = response.data.itemList;
            this.listLengthO = response.data.listLen;
            if(this.listLengthO === 0) this.$showMsg(this.$t('NOT_FOUND'));
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPageT = 1;
        this.curPageP = 1;
        this.curPageO = 1;
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.itemsT = [];
        this.itemsP = [];
        this.itemsO = [];
    },
    onRowSelectedT(items) {
        this.item = items[0];
        this.itemType = 't';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
        this.$router.push({
            path: '/Tour/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
        })
        }
    },
    onRowSelectedP(items) {
        this.item = items[0];
        this.itemType = 'p';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
        })
        }
    },
    onRowSelectedO(items) {
        this.item = items[0];
        this.itemType = 'o';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
        this.$router.push({
            path: '/Outing/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
        })
        }
    },
    clear() {
        this.geoType = '';
        this.selCountryRu = '';
        this.selCountryEn = '';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        this.optCountryRu = [{}],
        this.optCountryEn = [{}],
        this.optDistrictRu = [{}],
        this.optDistrictEn = [{}],
        this.optCityRu = [{}],
        this.optCityEn = [{}],
        this.getCountries();
        this.itemsT = [{}];
        this.itemsP = [{}];
        this.itemsO = [{}];
        this.listLengthT = 0;
        this.listLengthP = 0;
        this.listLengthO = 0;
        this.key++;
    },
    areaMap() {
        if(!this.countryEn) return;
        let country = this.countryEn;
        let district = this.districtEn ? this.districtEn : '_';
        let city = this.cityEn ? this.cityEn : '_';
        //console.log(country, district, city);
        this.$router.push({
            path: '/AreaMap/'+country+'/'+district+'/'+city
        })
    },
    async untie() {
        this.$bvModal.hide('modal-untie');
        this.untieGeo = false;
        //console.log(this.item.userName, this.item.itemName, this.item.itemType);
        try {
            const response = await this.$http.get('/refDel', {
                params: {
                    userName: this.item.userName,
                    itemName: this.item.itemName,
                    itemType: this.itemType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    intLoc: this.intLoc
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    retFromGeoChooser() {
        let chosenGeo = this.$refs.GeoChooser.getChosenGeo();
        if(this.intLoc === 'ru') {
            this.startCountry = chosenGeo.countryRu;
            this.startDistrict = chosenGeo.districtRu;
            this.startCity = chosenGeo.cityRu;
        }
        else {
            this.startCountry = chosenGeo.countryEn;
            this.startDistrict = chosenGeo.districtEn;
            this.startCity = chosenGeo.cityEn;
        }
        //this.geoChooser = false;
        this.ediKey++;  // ???
    },
    async del() {
        this.$bvModal.hide('modal-del');
        try {
            const response = await this.$http.get('/rmGeoItem', {
                params: {
                    refType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
        //this.getCountries();
    },
    curPageT: function() {
        this.getGeoTrips();
    },
    curPageP: function() {
        this.getGeoPlaces();
    },
    curPageO: function() {
        this.getGeoOutings();
    },
    selected: function() {
        this.clear();
    }
  },
  computed: {
    rowsT() {
        return this.listLengthT;
    },
    rowsP() {
        return this.listLengthP;
    },
    rowsO() {
        return this.listLengthO;
    },
    fields() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'userName', label: this.$t('AUTHOR') },
        { key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    },
    fieldsO() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'companyName', label: this.$t('ORG') },
        { key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    }

  }
}

</script>

<style>
</style>